import { render, staticRenderFns } from "./DiscussionThread.vue?vue&type=template&id=e52270e4&scoped=true"
import script from "./DiscussionThread.vue?vue&type=script&lang=js"
export * from "./DiscussionThread.vue?vue&type=script&lang=js"
import style0 from "./DiscussionThread.vue?vue&type=style&index=0&id=e52270e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52270e4",
  null
  
)

export default component.exports